import React, {Component} from 'react';

export default class AuthManage extends Component{
  render(){

    return (
        <div>{this.props.children}</div>
    )
  }
}
